module.exports = __webpack_public_path__ + "static/assets/9cf16e198b95ed7ff788cc318d836398.png";